export default __webpack_public_path__ + "static/media/Type 6.6c3eaa2d.jpg";